var map = {
	"./CI.svg": "f352",
	"./DZ.svg": "0b0c",
	"./EG.svg": "a53b",
	"./GH.svg": "f2b3",
	"./KE.svg": "621f",
	"./MA.svg": "c661",
	"./MX.svg": "26e5",
	"./NG.svg": "44af",
	"./PTM.svg": "a45a",
	"./SN.svg": "0fd9",
	"./TN.svg": "092d",
	"./UG.svg": "01c7",
	"./ZA.svg": "8939"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ba2";